import { useEffect } from "react";
import { toIcons } from "../../consts/Paths";
import useToggle from "../../hooks/useToggle";
import { formatDateGGMMYYYY } from "../../utils/reformatDate";

const TextInput = (props: any) => {
  const passwordToggler = useToggle(false);
  const copyToggler = useToggle(false);
  const copyAnimationToggler = useToggle(false);

  const copyIconChangeColor = () => {
    copyToggler.toggle();
  };
  useEffect(() => {
    if (copyToggler.isToggled) {
      copyToggler.setIsToggledSecondary(true);
      setTimeout(() => {
        copyToggler.setIsToggledSecondary(false);
      }, 3000);
    }
  }, [copyToggler.isToggled]);

  useEffect(() => {
    if (copyToggler.isToggledSecondary) {
      copyAnimationToggler.setIsToggled(true);
      setTimeout(() => {
        copyAnimationToggler.setIsToggled(false);
      }, 2000);
    }
  }, [copyToggler.isToggledSecondary]);

  const widthTypeString = typeof props.width === typeof "string";

  const isSocial =
    props.title === "Tiktok" ||
    props.title === "Facebook" ||
    props.title === "Instagram";
  const isPasswordType = props.type === "password";
  const isDateType = props.type === "Date";
  const isLocationType = props.locationIcon;

  return (
    <div
      className={`customInputText-box`}
      style={{
        width: widthTypeString
          ? `calc(${props.width} ${isPasswordType ? " + 30px" : ""})`
          : `${props.width + 30}px`,
        marginBottom: isSocial ? "-10px" : "",
      }}
    >
      {!isSocial && props.title && (
        <p className={`customInputText-title`}>{props.title}</p>
      )}
      <div style={{ display: "flex", gap: isSocial ? "22px" : "" }}>
        {isSocial && <img src={props.iconSrc} />}

        {props.register ? (
          <input
            className={`customInputText-input ${
              props.errors[props.name] && "onError"
            }`}
            placeholder={props.placeholder}
            {...props.register(props.name, props.constraints)}
            type={
              isPasswordType
                ? passwordToggler.isToggled
                  ? "text"
                  : props.type
                : props.type
            }
            defaultValue={props.defaultValue}
            value={props.value}
            disabled={props?.others?.disabled}
          />
        ) : (
          <input
            className={`customInputText-input`}
            placeholder={props.placeholder}
            type={
              isPasswordType
                ? passwordToggler.isToggled
                  ? "text"
                  : props.type
                : props.type
            }
            defaultValue={props.defaultValue}
            value={props.value}
            disabled={props?.others?.disabled}
          />
        )}

        {props.name && props.name.includes("password") && (
          <img
            className={`inputIcon ${
              passwordToggler.isToggled ? "offLightBlue" : ""
            }`}
            style={{
              transform: `translatex(-50px) translateY(13px)`,
            }}
            src={`${toIcons}/password.svg `}
            onClick={passwordToggler.toggle}
          />
        )}
        {/* {isDateType && !props?.noIcon && (
          <img
            className="inputIcon"
            style={{
              cursor: "default",
              transform: `translatex(-50px) translateY(13px)`,
            }}
            src={`${toIcons}/calendar.svg `}
          />
        )} */}
        {props.copyIcon && !props?.noIcon && (
          <div className="tooltipCopyIcon">
            <img
              className={`inputIcon ${
                copyToggler.isToggled && "offLightBlue"
              } `}
              style={{
                cursor: "pointer",
                transform: `translatex(-45px) translateY(13px)`,
              }}
              src={`${toIcons}/copy.svg `}
              onMouseDown={copyIconChangeColor}
              onMouseUp={copyIconChangeColor}
              onClick={() => {
                let tempvalue = "";
                if (props.watch) {
                  tempvalue = props.watch(`${props.name}`);
                } else tempvalue = props.value;
                navigator.clipboard.writeText(tempvalue);
              }}
            />
            {copyToggler.isToggledSecondary && (
              <span
                className={`tooltipCopyIconText ${
                  copyAnimationToggler.isToggled
                    ? "shiftUpFadeIn"
                    : "shiftDownFadeOut"
                } `}
              >
                link copied!
              </span>
            )}
          </div>
        )}
        {isLocationType && !props?.noIcon && (
          <img
            className="inputIcon black"
            style={{
              cursor: "pointer",
              transform: `translatex(-45px) translateY(13px)`,
            }}
            src={`${toIcons}/iconly-light-location.svg `}
          />
        )}
      </div>
    </div>
  );
};
export default TextInput;
